export var DATE_INPUT_FORMAT = 'MMM DD, YYYY'; // Date with leading zero to use in Date(Time) Pickers
export var DATETIME_INPUT_FORMAT = "".concat(DATE_INPUT_FORMAT, " HH:mm UTC"); // UTC isn't a recognised parsing token, but DayJS will still add it to the final string
export var DATE_FORMAT = 'MMM D, YYYY'; // Date without leading zero to use in all tables and paragraphs
export var DATETIME_FORMAT = "".concat(DATE_FORMAT, " HH:mm UTC"); // Date without leading zero to use in tables
export var DATETIME_FORMAT_WITH_SEC = "".concat(DATE_FORMAT, " HH:mm:ss UTC");
export var DATETIME_FORMAT_SHORT = 'MM/DD/YYYY HH:mm:ss';
